import React          from 'react'; 
import landscape      from './trust_it.module.css';
import portrait       from './portrait.module.css';
import Newspaper      from '../components/Newspaper.jsx';
import Paper          from '../components/Paper.jsx';
import {Context}      from '../services/context.js';

import pic_trust_it_1 from '../pictures/Luxery shoes.webp'; 
import pic_trust_it_2 from '../pictures/Palace Hotel San Francisco.webp'; 
import pic_trust_it_3 from '../pictures/Airplane Maintenence.webp'; 
import pic_trust_it_4 from '../pictures/Petty Cash.webp'; 
import { Helmet }     from 'react-helmet';

import cx             from 'classnames';

const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:   !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]:  !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:    !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:      !Context.portrait});
const cx_li     = cx({[portrait.li]:     Context.portrait, [landscape.li]:      !Context.portrait});

const images =[
  {title:'Pic 1', picture: pic_trust_it_1, index:1}, 
  {title:'Pic 2', picture: pic_trust_it_2, index:2},
  {title:'Pic 3', picture: pic_trust_it_3, index:3},
  {title:'Pic 4', picture: pic_trust_it_4, index:4}, ] ;

  const text_trust_it_1 = [
    {
      header: (
        <p className={cx_header}>
          Chirp with Trust.it
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Welcome to Trust.it! You’ll discover many use cases for Chirp—our microblogging feature. Imagine a Twitter‑like platform where even the wealthiest person in the world cannot delete or change content. That’s Chirp. Once a Chirp is recorded on the chain, it’s permanent. If you need to correct something, simply post a follow‑up Chirp referencing the original.
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Social media on the Back‑Step Blockchain is the next big trend. Every registered user automatically gets 16 account groups—including Chirp. Try it; our Chirp feature sets us apart from conventional social messaging systems.
        </p>
      )
    },
    {
      header: (
        <p className={cx_header}>
          Reduced Costs — Free Reading
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Sending a Chirp incurs a minimal fee, but reading messages is always free. Chirp is cost‑effective and transparent—you only pay for what you use. No Chirping? No charges. Enjoy consumption‑based pricing over standard subscriptions. Chirps cannot be encrypted and are limited to the size of a normal block. Surprisingly, Chirps up to 1024 characters cost only 50% of the normal block fee.
        </p>
      )
    },
    {
      header: (
        <p className={cx_header}>
          Upcoming Features
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Trust.it and Chirp are continually evolving. We’re excited to announce upcoming support for Chinese and Korean languages, as well as photo and video attachments for Chirps.
        </p>
      )
    },
    {
      header: (
        <p className={cx_header}>
          Early Adoption Notice
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Please note that Trust.it is still experimental. While we strive for reliability and stability, new feature rollouts may cause brief service interruptions. To protect your data, we recommend keeping local backups of your blockchain.
        </p>
      )
    },
    {
      header: (
        <p className={cx_header}>
          More about Trust.it
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Trust.it demonstrates the simplicity and robustness of building applications on the Back‑Step Blockchain. This platform serves as a secure repository for immutable records, ensuring your data’s integrity against any modification attempts. Each block holds up to 10 million bytes of payload data, with a small portion reserved for administrative details like user IDs and data types.
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Trust.it offers four modes of operation:
        </p>
      )
    },
    {
      text: (
        <ul className={cx_ul}>
          <li className={cx_li}>
            <strong>Chirp:</strong> our social media implementation on Trust.it.
          </li>
          <li className={cx_li}>
            <strong>Basic Text Mode:</strong> ideal for storing text data, with optional encryption for privacy.
          </li>
          <li className={cx_li}>
            <strong>File Security Mode:</strong> securely store large files on‑chain (up to 100 MB).
          </li>
          <li className={cx_li}>
            <strong>Large Block Mode:</strong> store only the file hash on‑chain, with external hosting for the data—supports encrypted blocks.
          </li>
        </ul>
      )
    },
    {
      text: (
        <p className={cx_text}>
          We also encourage the community to contribute innovative ideas.
        </p>
      )
    },
    {
      header: (
        <p className={cx_header}>
          Enhanced Privacy Features
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Trust.it includes a privacy mode that encrypts the block’s payload, ensuring even identical texts produce distinct blocks. Future updates will add group functionalities for shared access among selected users.
        </p>
      )
    },
    {
      header: (
        <p className={cx_header}>
          Fair Pricing Structure
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Trust.it uses a modest fee structure to maintain service quality and prevent spam. Fees (pegged to the U.S. dollar) are:
        </p>
      )
    },
    {
      text: (
        <ul className={cx_ul}>
          <li className={cx_li}>
            <strong>Standard Block:</strong> 2 units
          </li>
          <li className={cx_li}>
            <strong>Encrypted Block:</strong> 3 units
          </li>
          <li className={cx_li}>
            <strong>Large Blocks:</strong> +2 units per MB
          </li>
        </ul>
      )
    },
    {
      text: (
        <p className={cx_text}>
          These fees cover indefinite storage, network transactions, and maintenance—plus no advertising on our platform. We also offer specialized rates for advertising blocks to ensure a non‑intrusive user experience.
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Owners of Back‑Step Blockchain Generators running their own applications can set custom pricing and receive volume discounts for transactions on their chains.
        </p>
      )
    }
  ];
  
  const text_trust_it_2 = [
    {
      header: (
        <p className={cx_header}>
          Technical Insights
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Each block in our blockchain comprises four distinct data sections:
        </p>
      )
    },
    {
      text: (
        <ul className={cx_ul}>
          <li className={cx_li}>
            <strong>Metadata:</strong> the DNA of each block, describing its properties.
          </li>
          <li className={cx_li}>
            <strong>Payload Data:</strong> the application‑specific content.
          </li>
          <li className={cx_li}>
            <strong>Payload Security Data:</strong> secures the payload via a payload hash and the MoMu value, which is forward‑chained among blocks.
          </li>
          <li className={cx_li}>
            <strong>Block Security Data:</strong> includes the Back‑Step seal and block hash.
          </li>
        </ul>
      )
    },
    {
      text: (
        <p className={cx_text}>
          For Trust.it, we defined a transparent payload structure with fields for user IDs, user groups, and block types. Trust.it uses nine block types to support its features.
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Examples of block types include:
        </p>
      )
    },
    {
      text: (
        <ul className={cx_ul}>
          <li className={cx_li}><strong>Native Block</strong></li>
          <li className={cx_li}><strong>Encrypted Block</strong></li>
          <li className={cx_li}><strong>Reference Block</strong></li>
          <li className={cx_li}><strong>Concatenation Block</strong></li>
          <li className={cx_li}><strong>Group Block</strong></li>
          <li className={cx_li}><strong>Invalidate Block</strong></li>
          <li className={cx_li}><strong>Advertisement Block</strong></li>
          <li className={cx_li}><strong>Message Block</strong></li>
          <li className={cx_li}><strong>Payment Block</strong></li>
          <li className={cx_li}><strong>Fee Transfer Block</strong></li>
          <li className={cx_li}><strong>Priority Mail Block</strong></li>
          <li className={cx_li}><strong>Chirp Block</strong></li>
          <li className={cx_li}><strong>File Block</strong></li>
        </ul>
      )
    },
    {
      text: (
        <p className={cx_text}>
          Trust.it allocates 100 TB of blockchain storage—far more than traditional chains—with plans to expand to 1 PB to support rapid growth for both businesses and individual users.
        </p>
      )
    },
    {
      text: (
        <p className={cx_text}>
          To ensure integrity and efficiency, Trust.it includes both automatic and manual chain‑verification mechanisms. Users can download and verify the chain locally. To prevent overload, the system limits parallel verifications to a percentage of available bandwidth. Clients can use checkpoints at recent verifications to optimize performance.
        </p>
      )
    }
  ];
  
export class TrustIt extends React.Component
{
    //------------------------------------------------------------------
    //  Constructor
    //------------------------------------------------------------------
    constructor(props) 
    {
      super(props);
      this.component= "";
      this.state = {content_disabled: false}
    }  

    componentDidMount()
    {
      //console.log('Component did mount in TrustIt');
      window.scrollTo({top:0, left: 0, behavious: 'smooth'});

    };
   
      //------------------------------------------------------------------
      //
      //------------------------------------------------------------------
      changeVisible(mode)
      {
        this.setState({content_disabled:mode})
      }

    //------------------------------------------------------------------
    //  Prepare the render output
    //------------------------------------------------------------------
    render()
    { 
      if (Context.portrait)
        {
            this.component = 

              <div className={portrait.backdrop}>

              <Helmet>
                <title>Trust.it online Back-Step for everybody</title>
                <meta name="description" content="Trust.t is your blockchain on the web. Fast, cheap and faszinating easy. The application is 100% fee.  " />
                <meta charset="utf-8" />
              </Helmet>
 
                  <div className={cx_title}>
                      Trust.it - Your Back-Step Blockchain! 
                  </div>

                  <div > 
                      <Paper key ={1} textLines = {text_trust_it_1}/> 
                  </div>

                  <div>
                      <Paper key ={2} textLines = {text_trust_it_2}/>
                  </div>
              </div>
        }
        else
        {
          this.component = 
          <div className={landscape.backdrop} onMouseDown={()=>this.changeVisible(true)} onMouseUp={()=>this.changeVisible(false)} onContextMenu={(e) => e.preventDefault()}>
            
             <Helmet>
              <title>Trust.it the online app</title>
              <meta name="description" content="Trust.t is your blockchain on the web. Fast, cheap and faszinating easy. The application is 100% fee.  " />
              <meta charset="utf-8" />
              </Helmet>

            { ! this.state.content_disabled &&
              <>
                <div className={landscape.title_location}>
                  <div className={landscape.title_text}>
                    <p>Trust.it - Your Back-Step Blockchain!</p>
                  </div>
                </div>

<div className={landscape.container}>

                <div> 
                < Newspaper key ={3} textLines = {text_trust_it_1}/> 
                </div>

                <div>
                  <Newspaper  key ={4} textLines = {text_trust_it_2}/>
                </div>

              </div>
              </>
            }
        </div>

        }
      return this.component ;
    }
}  

